/* Password policy (same rules as the API: min 8, letters + digits, max 128) and a strength estimate for the meter. */
export function passwordProblem(pw: string): string {
  if ([...pw].length < 8) return "must be at least 8 characters";
  if (pw.length > 128) return "must be at most 128 characters";
  if (!/\p{L}/u.test(pw) || !/\p{N}/u.test(pw)) return "must contain letters and digits";
  return "";
}

/** 0 (empty) … 4 (strong). */
export function passwordStrength(pw: string): 0 | 1 | 2 | 3 | 4 {
  if (!pw) return 0;
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/\p{Ll}/u.test(pw) && /\p{Lu}/u.test(pw)) score++;
  if (/\p{N}/u.test(pw) && /[^\p{L}\p{N}]/u.test(pw)) score++;
  if (passwordProblem(pw)) score = Math.min(score, 1);
  return Math.max(1, Math.min(4, score)) as 1 | 2 | 3 | 4;
}

export const RULES: { id: string; en: string; ar: string; test: (pw: string) => boolean }[] = [
  { id: "len", en: "8+ characters", ar: "8 أحرف على الأقل", test: (pw) => [...pw].length >= 8 },
  { id: "letter", en: "a letter", ar: "حرف", test: (pw) => /\p{L}/u.test(pw) },
  { id: "digit", en: "a digit", ar: "رقم", test: (pw) => /\p{N}/u.test(pw) },
];
